<div
  class="panel-default"
  *ngIf="!startupService.isStarted || startupService.isStarting || startupService.hasFailed"
>
  <div class="card">
    <!-- this component is only visible if the startup service is currently either loading the application or has failed during that process -->
    <div class="card-header">{{ APP_TITLE }}</div>
    <div class="card-body" *ngIf="!startupService.hasFailed">
      <div
        class="line"
        *ngFor="let startupInfo of startupInfoList"
        [ngClass]="{
          loading: startupInfo.isLoading,
          finished: startupInfo.isDone
        }"
      >
        {{ startupInfo.title | translate }}
      </div>
    </div>
    <startup-errors *ngIf="startupService.hasFailed"></startup-errors>
  </div>
</div>
